import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import CopyIcon from '@material-ui/icons/FileCopyOutlined';
import IconButton from '@material-ui/core/IconButton';
import LinePng from '../img/line.png';
import TwitterPng from '../img/twitter.png'; 
import './PopupToShareUrl.css';

// 共有リンクポップアップ
export default class PopupToShareUrl extends React.Component {
  copyLinkText(text) {
    navigator.clipboard.writeText(text)
  }

  render() {
    let link = "https://" + process.env.REACT_APP_SHARELINK_URL_DOMAIN + "/" + this.props.editor;
    if (this.props.pid !== null) {
      link += "/" + this.props.pid;
    }
    return (
      <div className='popup'>
        <div className='popup_inner'>
          <h1>{this.props.text}</h1>
          <div className={"copydiv"}>
            <TextField className={"inputbox"} variant="outlined"
              value={link} readOnly
            />
            <CopyIcon className={"copyicon"} fontSize="large" onClick={this.copyLinkText(link)} />
          </div>
          <p>{this.props.subtext}</p>
          <div className={"pagesnsicon"}>
            <IconButton aria-label="linebtn" component={"a"}
              href={"https://social-plugins.line.me/lineit/share?url=" + encodeURIComponent(link)}
            >
              <div className={"pagesnsiconbtn"}>
                <img src={LinePng} className={"pagesnsiconimg"} />
                <label className={"pagesnsiconlabel"}>LINEで共有</label>
              </div>
            </IconButton>
            <IconButton aria-label="twitterbtn" component={"a"}
              href={"https://twitter.com/intent/tweet?hashtags=SelectBook&text=このSelectBookに共感しました！&url=" + encodeURIComponent(link)}
            >
              <div className={"pagesnsiconbtn"}>
                <img src={TwitterPng} className={"pagesnsiconimg"} />
                <label className={"pagesnsiconlabel"}>Twitterで共有</label>
              </div>
            </IconButton>
          </div>
          <Button type="button" variant="contained" color="primary" onClick={this.props.closePopup}>
            閉じる
          </Button>
        </div>
      </div>
    );
  }
}
